import {all, fork, takeEvery} from 'redux-saga/effects';
import {fetchDeliveryManagerManifestWorker} from './DeliveryManagerManifestWorkers';
import {GET_DELIVERY_MANAGER_MANIFEST} from '../DeliveryManagerManifestAction';

export function* deliveryManagerManifestWatcher() {
    yield takeEvery(GET_DELIVERY_MANAGER_MANIFEST, fetchDeliveryManagerManifestWorker);
}

export default function* watchDeliveryManagerManifest() {
    yield all([
        fork(deliveryManagerManifestWatcher)
    ])
}
